import { TableRow, TableCell, Checkbox } from '@occc/ui-design-system';
import { NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';
import { Cpg, SubmissionGroupLocationFragment } from '@occc/graphql';

import { CpgAccountDataCells } from './cpg-account-cells';
import { isLocationSelectableForCpg } from './submission-group-locations-table.utils';

type SubmissionGroupLocationsTableRowProps = {
  cpg: Cpg;
  location: SubmissionGroupLocationFragment;
  isItemSelected: boolean;
  handleItemSelect: (id: string) => void;
};

export const SubmissionGroupLocationsTableRow = ({
  cpg,
  location,
  isItemSelected,
  handleItemSelect,
}: SubmissionGroupLocationsTableRowProps) => {
  const address = location.address;
  const locationCity = address?.city || '';
  const locationState = address?.state || '';
  const locationStreet = address?.street1 || '';
  const locationZip = address?.zipCode || '';

  const siteId = location.siteSystemConfiguration?.[0]?.identifier || NO_DATA_PLACEHOLDER;
  const siteName =
    location.siteSystemConfiguration?.[0]?.details?.siteName || location.address?.alias || siteId;

  const sitePhoneNumber = location.phoneNumbers[0]?.phoneNumber || NO_DATA_PLACEHOLDER;

  const isSelectable = isLocationSelectableForCpg(location, cpg);

  return (
    <TableRow key={location.uuid} selected={isItemSelected}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={isItemSelected}
          disabled={!isSelectable}
          onClick={(event) => {
            event.stopPropagation();
            handleItemSelect(location.uuid);
          }}
        />
      </TableCell>
      <TableCell>{siteId}</TableCell>
      <TableCell>{siteName}</TableCell>
      <CpgAccountDataCells cpg={cpg} location={location} />
      <TableCell>{`${locationStreet} ${locationCity}, ${locationState} ${locationZip}`}</TableCell>
      <TableCell>{sitePhoneNumber}</TableCell>
    </TableRow>
  );
};
